import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProgressBarComponent } from '../progress-bar/progress-bar.component';
import { JobProgress, STEP_COUNT, errorText, jobHeadline, jobTimeText, jobValueText } from './job-progress.model';

/**
 * A running or queued job in three short lines: the stage and the overall
 * percentage, a thin bar, then step dots with the time so far and the time
 * left (or the queue position). The lines keep their height in every state.
 */
@Component({
  selector: 'app-job-progress',
  templateUrl: './job-progress.component.html',
  styleUrl: './job-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressBarComponent],
  host: { '[class.job--fit-row]': 'fitRow()' },
})
export class JobProgressComponent {
  readonly job = input.required<JobProgress>();
  /** Inside a table row: on phones, where the row is one name tall, the time line gives way. */
  readonly fitRow = input(false);

  readonly steps = Array.from({ length: STEP_COUNT }, (_, i) => i);

  readonly headline = computed(() => jobHeadline(this.job()));
  readonly timeText = computed(() => jobTimeText(this.job()));
  readonly valueText = computed(() => jobValueText(this.job()));
  readonly errors = computed(() => this.job().runs?.errors ?? 0);
  readonly errorText = computed(() => errorText(this.errors()));
}
